module.exports = __webpack_public_path__ + "img/subtray.88135121.png";